module.exports = __webpack_public_path__ + "img/team-01.aa762547.jpg";